import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { ROUTES } from '@/constants/routes';
import { LogOut } from 'lucide-react';

export function PageTopBar() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate(ROUTES.LOGIN);
  };

  return (
    <div className="mb-3 flex items-center justify-end sm:mb-4 print:hidden">
      <div className="flex items-center gap-3">
        <span className="hidden text-sm text-gray-600 sm:inline">{user?.email}</span>
        <Button variant="outline" size="sm" className="min-h-11" onClick={handleSignOut}>
          <LogOut className="h-4 w-4 mr-2" />
          Sign Out
        </Button>
      </div>
    </div>
  );
}
